export const APIConfig = {
	baseUrl:
		process.env.REACT_APP_PROCUREMENTGPT_SERVICE_API ||
		'https://procurementgpt-service-stag.thodin.tendium.net',
};
